import { Switch, Form, Typography } from 'antd'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { ConfigCard } from './styles'

const FormItem = Form.Item
const Text = Typography.Text

const AllowAddendums = ({ initialAllowAddendums }) => {
	const [enabled, setEnabled] = useState(initialAllowAddendums ?? false)

	const handleChange = (checked) => {
		setEnabled(checked)
	}

	return (
		<ConfigCard
			title="Permitir Aditivos"
			extra={
				<FormItem
					name="allowAddendums"
					valuePropName="checked"
					initialValue={enabled}>
					<Switch checked={enabled} onChange={handleChange} />
				</FormItem>
			}>
			<Text>
				Quando esta opção estiver ativada, os usuários poderão adicionar
				aditivos ao documento.
			</Text>
		</ConfigCard>
	)
}

AllowAddendums.propTypes = {
	initialAllowAddendums: PropTypes.bool,
}

export default AllowAddendums
